<div class="main overflow-hidden">
    <app-scrollup></app-scrollup>
    <app-header-three></app-header-three>
    <app-hero-one></app-hero-one>
    <router-outlet></router-outlet>
    <app-footer-one></app-footer-one>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
</div>
